import {
    AccountWarehousesDataItem,
    MirWarehouseItem
} from '@apis/materialsInReview/MaterialsInReview.types';
import { capitalize } from '@helpers/stringHelper';
import { useTreeData } from '@hooks/useTreeData';

interface Props {
    selectedItems: string[];
    data: AccountWarehousesDataItem[];
    isDataLoading?: boolean;
}

const getWarehouseTitle = (warehouse: MirWarehouseItem, country: string) => {
    const { code, alias, city } = warehouse;
    const isCity = city ? capitalize(city) : '';

    return `${code}${alias ? ` (${alias})` : ''}, ${isCity}, ${country}`;
};

export const useWarehouseFilter = ({
    selectedItems,
    data,
    isDataLoading
}: Props) => {
    const treeData = data.map(
        ({ regionName, regionCode, countries }) =>
            ({
                title: regionName,
                value: `region-${regionCode}`,
                children: countries.map(
                    ({ countryName, countryCode, ssls }) => {
                        const countryNameCapitalized = capitalize(countryName);

                        return {
                            title: countryNameCapitalized,
                            value: `${regionCode}_${countryCode}`,
                            children: ssls.map((ssl) => ({
                                title: getWarehouseTitle(
                                    ssl,
                                    countryNameCapitalized
                                ),
                                value: ssl.code
                            }))
                        };
                    }
                )
            } || [])
    );

    const {
        popupRef,
        getCustomPopupContainer,
        onTreeInit,
        areSelectedKeysChanged,
        handleChange,
        onRemoveSearchBadge,
        selectedKeys,
        onClearClick
    } = useTreeData({
        defaultSelectedKeys: selectedItems,
        isDataLoading
    });

    return {
        popupRef,
        treeData,
        selectedKeys,
        handleChange,
        onTreeInit,
        areSelectedKeysChanged,
        onClearClick,
        onRemoveSearchBadge,
        getCustomPopupContainer
    };
};
